document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('[data-jc-modal-overlay]');
  if (!overlay) return;

  var titleEl = overlay.querySelector('[data-jc-modal-title]');
  var jobIdEl = overlay.querySelector('[data-jc-modal-jobid]');
  var locationEl = overlay.querySelector('[data-jc-modal-location]');
  var logoEl = overlay.querySelector('[data-jc-modal-logo]');
  var descriptionEl = overlay.querySelector('[data-jc-modal-description]');
  var skillsEl = overlay.querySelector('[data-jc-modal-skills]');
  var skillsSectionEl = overlay.querySelector('[data-jc-modal-skills-section]');
  var datesEl = overlay.querySelector('[data-jc-modal-dates]');
  var applyEl = overlay.querySelector('[data-jc-modal-apply]');
  var closeButtons = overlay.querySelectorAll('[data-jc-modal-close]');

  var lastFocusedElement = null;

  function openModal(card) {
    var jobTitle = card.getAttribute('data-job-title') || '';
    var jobId = card.getAttribute('data-job-id') || '';
    var location = card.getAttribute('data-location') || '';
    var logoText = card.getAttribute('data-logo-text') || jobTitle.charAt(0);
    var logoColor = card.getAttribute('data-logo-color') || '#000000';
    var descriptionFull = card.getAttribute('data-description-full') || card.getAttribute('data-description-short') || '';
    var skills = (card.getAttribute('data-skills') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var postedDate = card.getAttribute('data-posted-date') || '';
    var expiresDate = card.getAttribute('data-expires-date') || '';
    var postedShow = card.getAttribute('data-posted-show') || false;
    var skillShow = card.getAttribute('data-skill-show') || false;
    var applyUrl = card.getAttribute('data-apply-url') || '';
    

    titleEl.textContent = jobTitle;
    jobIdEl.textContent = jobId;
    locationEl.textContent = location;
    logoEl.textContent = logoText;
    logoEl.style.background = logoColor;
    descriptionEl.textContent = descriptionFull;

    skillsEl.innerHTML = '';
    if (skillShow === 'true') {
      console.log("CARD: ", typeof skillShow);  
      skillsSectionEl.hidden = false;
      skillsSectionEl.style.display = 'block';
      skills.forEach(function (skill) {
        var span = document.createElement('span');
        span.className = 'jc-skill';
        span.textContent = skill;
        skillsEl.appendChild(span);
      });
    } else {
      skillsSectionEl.hidden = true;
      skillsSectionEl.style.display = 'none';
    }

    datesEl.innerHTML = '';
    if (postedDate && postedShow === 'true') {
      var postedSpan = document.createElement('span');
      postedSpan.innerHTML = 'Posted on <strong>' + postedDate + '</strong>';
      datesEl.appendChild(postedSpan);
    }

    if (postedShow === 'true' && postedDate && expiresDate) {
      var divider = document.createElement('span');
      divider.className = 'jc-date-divider';
      datesEl.appendChild(divider);
    }
    if (expiresDate && postedShow === 'true') {
      var expiresSpan = document.createElement('span');
      expiresSpan.innerHTML = 'Expires on <strong>' + expiresDate + '</strong>';
      datesEl.appendChild(expiresSpan);
    }

    if (applyUrl) {
      applyEl.href = applyUrl;
      applyEl.style.display = 'inline-block';
    } else {
      applyEl.style.display = 'none';
    }

    lastFocusedElement = document.activeElement;
    overlay.hidden = false;
    void overlay.offsetWidth;
    overlay.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    closeButtons[0].focus();
  }

  function closeModal() {
    overlay.removeAttribute('data-open');
    document.body.style.overflow = '';
    var onTransitionEnd = function () {
      overlay.hidden = true;
      overlay.removeEventListener('transitionend', onTransitionEnd);
    };
    overlay.addEventListener('transitionend', onTransitionEnd);
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  if (applyEl) {
    applyEl.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();

        const target = document.querySelector('#BJVAjWt3yS4hBeIiet4liQ');

        if (target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        }
    });
  }

  document.querySelectorAll('[data-jc-card]').forEach(function (card) {
    // Track whether the pointer moved (dragged) before treating a click as "open"
    var pointerDownX = 0;
    var pointerDownY = 0;
    var dragged = false;

    card.addEventListener('pointerdown', function (e) {
      pointerDownX = e.clientX;
      pointerDownY = e.clientY;
      dragged = false;
    });

    card.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - pointerDownX) > 6 || Math.abs(e.clientY - pointerDownY) > 6) {
        dragged = true;
      }
    });

    card.addEventListener('click', function (e) {
      if (dragged) return;
      if (e.target.closest('[data-jc-share]')) return;
      openModal(card);
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal(card);
      }
    });
  });

  document.querySelectorAll('[data-jc-share]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = btn.closest('[data-jc-card]');
      var jobTitle = card ? card.getAttribute('data-job-title') : document.title;
      if (navigator.share) {
        navigator.share({ title: jobTitle, url: window.location.href }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href);
      }
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.hasAttribute('data-open')) {
      closeModal();
    }
  });
});
